export const AI_ASSISTANT_VIEW = "/assistant"
export const AI_ASSISTANT_THREAD_VIEW = `${AI_ASSISTANT_VIEW}/:threadId`
export const AI_ASSISTANT_THREADS_LIST_VIEW = `${AI_ASSISTANT_VIEW}/chats`
